/**
 * Reducers specify how the application's state changes in response to actions. This reducer is responsible
 * for actions started from "Main" higher-order component (Main.stx).
 *
 * A reducer takes the current state and the action.payload (data) that will change the current state and return the new state.
 */

import { MainActions, MainActionsEnum } from "../actions/mainActions";
import { mainInitialState } from "./initialState";

const mainReducer = (state: State.Main = mainInitialState, action: MainActions): State.Main => {
  switch (action.type) {
    case MainActionsEnum.SET_FETCHING_STATUS: {
      const fetchingStatus = action.payload;
      return { ...state, fetchingStatus };
    }
    case MainActionsEnum.SET_ACTIVE_SUBMENU: {
      const activeSubmenu = action.payload;
      return { ...state, activeSubmenu };
    }
    case MainActionsEnum.SET_ACTIVE_USER: {
      const activeUser = action.payload;
      return { ...state, activeUser };
    }
    case MainActionsEnum.SET_EDIT_SIZE: {
      const editSize = action.payload;
      return { ...state, editSize };
    }
    case MainActionsEnum.SET_PAGE_SIZE: {
      const pageSize = action.payload;
      return { ...state, pageSize };
    }
    case MainActionsEnum.SET_SHORTEN_TEXT_STATUS: {
      const isShortenTextEnabled = action.payload;
      return { ...state, isShortenTextEnabled };
    }
    case MainActionsEnum.SET_LAST_EDITED_OBJECT_ID: {
      const { id, parentid } = action.payload;
      return { ...state, lastEditedObjectId: id, lastSelectedParentObjectId: parentid };
    }
    default:
      return state;
  }
};

export default mainReducer;
